<script setup>
import {computed} from 'vue'
import {useStore} from "vuex";
// форматирование суммы
import {priceFormat} from '@/use/price-format'
//----------------------------------------------------------------------
const store = useStore()

// для графика платежей
const payments = computed( () => {return store.getters['contractModule/payments']})

</script>
<template>

  <div class="card card-outline card-info">
    <div class="card-body">
    <div class="table-responsive">
    <table
        class="table text-center"
    >
      <thead>
      <tr>
        <th style="width: 15%" class="border-0">Дата<br>платежа</th>
        <th style="width: 15%" class="border-0">Сумма<br>платежа</th>
        <th style="width: 15%" class="border-0">Сумма<br>долга</th>
        <th style="width: 15%" class="border-0">Сумма<br>процентов</th>
        <th style="width: 20%" class="border-0">Задолженность<br>на конец периода</th>
        <th style="width: 20%" class="border-0">Досрочный<br>платеж</th>
      </tr>
      </thead>
      <tbody>
      <tr
          v-for="(item,index) in payments"
          :key="index"
          :class="[item.PaymentСompleted === 1 ? 'bg-past-period' : 'bg-future-period']"
      >
        <td>{{ item.Date }}</td>
        <td>{{ priceFormat(item.Summ) }}</td>
        <td>{{ priceFormat(item.Debt) }}</td>
        <td>{{ priceFormat(item.Percent) }}</td>
        <td>{{ priceFormat(item.Balance) }}</td>
        <td>{{ priceFormat(item.Prepayment) }}</td>
      </tr>
      </tbody>
    </table>
    </div>
  </div>
  </div>
</template>
<style scoped>
.bg-past-period{background-color: #eff0f1}
.bg-future-period{background-color: #fff}
</style>